<template>
  <div>
    <div class="cooperation_wrap">
      <div class="cooperation_tit">
        <div>运行机制</div>
        <div class="en-font">Operation Mechanism</div>
      </div>
      <div class="cooperation_desc">
        <div>“公司+联盟+专家委员会”、 市场化运营与可持续发展</div>
        <div class="en-font">
          The "Enterprise + Alliance + Expert Committee" model, market-oriented
        </div>
      </div>
      <div class="cooperation_box">
        <div class="warp">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="img_box">
              <img :src="item.img" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          img: require("@/assets/run1.png"),
          title: "科学决策机制",
        },
        {
          img: require("@/assets/run2.png"),
          title: "高效管理机制",
        },
        {
          img: require("@/assets/run3.png"),
          title: "创新激励机制",
        },
        {
          img: require("@/assets/run4.png"),
          title: "自我造血机制",
        },
        {
          img: require("@/assets/run5.png"),
          title: "资源共享机制",
        },
        {
          img: require("@/assets/run6.png"),
          title: "协同创新机制",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cooperation_wrap {
  width: 100%;
  text-align: center;
  background: url("~@/assets/img/bottom_bg.90c1ea1.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  padding-bottom: 60px;
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 50px;
    .en-font {
      font-size: 20px;
    }
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      .en-font {
        font-size: 0.6rem;
      }
    }
  }
  .cooperation_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
    .en-font {
      font-size: 20px;
    }
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      .en-font {
        font-size: 0.6rem;
      }
    }
  }
  .cooperation_box {
    width: 90%;
    margin: 0 auto;
    padding-top: 50px;
    position: relative;
    .warp {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 14%;
        background: #fff;
        border-radius: 20px;
        box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
        overflow: hidden;
        transition: all 0.3s;
        @media screen and (max-width: 768px) {
          width: 30%;
          margin-bottom: 10px;
        }
        &:hover {
          transform: scale(1.05);
        }
        img {
          width: 100%;
          height: 200px;
          @media screen and (max-width: 768px) {
            height: 80px;
          }
        }
        .title {
          padding: 5px 0;
          font-size: 15px;
          font-weight: 600;
          @media screen and (max-width: 768px) {
            font-size: 8px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>